// src/backendServices/broadcastingManagment/api_thirdPartyStreamingSystem.ts


import   axios                                    from 'axios';
import { API_URLS                              }  from '../urls';
import { ThirdPartyStreamingService            ,
         ThirdPartyStreamingChannel            ,
         initializedThirdPartyStreamingService ,
         initializedThirdPartyStreamingChannel }  from '../../dataTypes/broadcastingManagment/types_thirdPartyStreamingSystem';
import { BackendResponse                       }  from '../../dataTypes/backendServicesManagment/types';

export interface BackendResponse_ThirdPartyStreamingServiceList extends BackendResponse {
  payload: ThirdPartyStreamingService[];
}

const handleError_ThirdPartyStreamingServiceList = (status: number, error: string): BackendResponse_ThirdPartyStreamingServiceList => {
  return {
    code: status,
    comment: error,
    payload: [],
  };
};


export const getThirdPartyStreamingServices = async (): Promise<BackendResponse_ThirdPartyStreamingServiceList> => {

  console.log ('getThirdPartyStreamingServices')

  const url = API_URLS.getThirdPartyStreamingServices;

  console.log ('getThirdPartyStreamingServices', url)

  try
   {
    const response = await axios.get(url);

    console.log ('getThirdPartyStreamingServices', response)
  
    if (response.status === 200)
          {
           const defaultService = initializedThirdPartyStreamingService();

           const services: ThirdPartyStreamingService[] = response.data["hydra:member"].map((rawService: any) => ({
             ...defaultService,
             id           : rawService?.id           ?? defaultService.id,
             active       : rawService?.active       ?? defaultService.active,
             name         : rawService?.name         ?? defaultService.name,
             description  : rawService?.description  ?? defaultService.description,
             ingestionUrl : rawService?.ingestionUrl ?? defaultService.ingestionUrl,
             watchUrl     : rawService?.watchUrl     ?? defaultService.watchUrl,
             rank         : rawService?.rank         ?? defaultService.rank,
            }));

           services.sort((a, b) => (a.rank ?? 0) - (b.rank ?? 0));

           return {
             code: 1,
             comment: 'The retrieval of streaming services is complete.',
             payload: services,
            };
          }
     else {
           return handleError_ThirdPartyStreamingServiceList (response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError_ThirdPartyStreamingServiceList (-101, error.response?.data?.detail ?? error.message);
     }

    return handleError_ThirdPartyStreamingServiceList(-102, 'Unknown error');
   }
};


export interface BackendResponse_ThirdPartyStreamingChannelList extends BackendResponse {
  payload: ThirdPartyStreamingChannel[];
}

const handleError_ThirdPartyStreamingChannelList = (status: number, error: string): BackendResponse_ThirdPartyStreamingChannelList => {
  return {
    code: status,
    comment: error,
    payload: [],
  };
};

export const getThirdPartyStreamingChannels = async (): Promise<BackendResponse_ThirdPartyStreamingChannelList> => {

  const url = API_URLS.getThirdPartyStreamingChannels;

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
          {
           const defaultChannel = initializedThirdPartyStreamingChannel();

           const channels: ThirdPartyStreamingChannel[] = response.data.map((rawChannel: any) => ({
              ...defaultChannel,
              id                           : rawChannel?.id                           ?? defaultChannel.id,
              active                       : rawChannel?.active                       ?? defaultChannel.active,
              name                         : rawChannel?.name                         ?? defaultChannel.name,
              description                  : rawChannel?.description                  ?? defaultChannel.description,
              ingestionKey                 : rawChannel?.ingestionKey                 ?? defaultChannel.ingestionKey,
              streamUrl                    : rawChannel?.streamUrl                    ?? defaultChannel.streamUrl,
              backupUrl                    : rawChannel?.backupUrl                    ?? defaultChannel.backupUrl,
              broadcastingChannelId        : rawChannel?.broadcastingChannelId        ?? defaultChannel.broadcastingChannelId,
              thirdPartyStreamingServiceId : rawChannel?.thirdPartyStreamingServiceId ?? defaultChannel.thirdPartyStreamingServiceId,
             }));

      return {
        code: 1,
        comment: 'The retrieval of streaming channels is complete.',
        payload: channels,
      };
    } else {
      return handleError_ThirdPartyStreamingChannelList (response.status, 'Non-200 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError_ThirdPartyStreamingChannelList (-101, error.response?.data?.detail ?? error.message);
    }

    return handleError_ThirdPartyStreamingChannelList (-102, 'Unknown error');
  }
};





// Définir l'interface pour la réponse du backend
export interface BackendResponse_ThirdPartyStreamingChannel extends BackendResponse {
  payload: ThirdPartyStreamingChannel;
}

// Fonction pour gérer les erreurs
const handleError_ThirdPartyStreamingChannel = (status: number, error: string): BackendResponse_ThirdPartyStreamingChannel => {
  return {
    code: status,
    comment: error,
    payload: initializedThirdPartyStreamingChannel(),
  };
};

// Fonction pour créer un canal de streaming tiers
export const createThirdPartyStreamingChannel = async ( channelData: ThirdPartyStreamingChannel ): Promise<BackendResponse_ThirdPartyStreamingChannel> =>  {
  const url = API_URLS.createThirdPartyStreamingChannel;

  console.log ('createThirdPartyStreamingChannel : ', url)

  const formData = new FormData();

  // Ajout des champs principaux du canal
  formData.append ('id'                           , channelData.id.toString());
  formData.append ('active'                       , channelData.active.toString());
  formData.append ('name'                         , channelData.name);
  formData.append ('description'                  , channelData.description);
  formData.append ('ingestionKey'                 , channelData.ingestionKey);
  formData.append ('streamUrl'                    , channelData.streamUrl);
  formData.append ('backupUrl'                    , channelData.backupUrl);
  formData.append ('broadcastingChannelId'        , channelData.broadcastingChannelId.toString());
  formData.append ('thirdPartyStreamingServiceId' , channelData.thirdPartyStreamingServiceId.toString());

  const headers = {
    'Accept': 'application/ld+json',
  };

  try
   {
    const response = await axios.post(url, formData, { headers }); 

  console.log ('createThirdPartyStreamingChannel : ', response)

    if (response.status === 201) {
      return {
        code: 1,
        comment: 'The streaming channel has been created successfully.',
        payload: response.data,
      };
    } else {
      return handleError_ThirdPartyStreamingChannel (response.status, 'Non-201 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError_ThirdPartyStreamingChannel (-101, error.response?.data?.detail ?? error.message);
    }

    return handleError_ThirdPartyStreamingChannel (-102, 'Unknown error');
  }
};


export const updateThirdPartyStreamingChannel = async ( channelId   : number                              ,
                                                        updatedData : Partial<ThirdPartyStreamingChannel> ): Promise<BackendResponse_ThirdPartyStreamingChannel> => {
  const url = `${API_URLS.updateThirdPartyStreamingChannel}/${channelId}`;

  try {
    const response = await axios.put(url, updatedData);

    if (response.status === 200) {
      return {
        code: 1,
        comment: 'The streaming channel has been updated successfully.',
        payload: response.data,
      };
    } else {
      return handleError_ThirdPartyStreamingChannel(response.status, 'Non-200 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError_ThirdPartyStreamingChannel(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError_ThirdPartyStreamingChannel(-102, 'Unknown error');
  }
};

/*
  activateBroadcastingChannelInternalStreamingService    : getApiUrl ( '/broadcasting_channels/{id}/activation' ) ,
  desactivateBroadcastingChannelInternalStreamingService : getApiUrl ( '/broadcasting_channels/{id}/desactivation' ) ,
  controlBroadcastingChannelThirdPartyStreamingService   : getApiUrl ( '/broadcasting_channels/{id}/thirdPartyStreamingSystem' ) ,
*/

export const toggleThirdPartyStreamingChannelActiveStatus = async ( channelId                    : number  ,
                                                                    thirdPartyStreamingServiceId : number  ,
                                                                    active                       : boolean ,
																	streamUrl                    : string  ,
																	ingestionKey                 : string  ): Promise<BackendResponse_ThirdPartyStreamingChannel> => {

  const baseUrl = `${API_URLS.controlBroadcastingChannelThirdPartyStreamingService}`;
  const url     = baseUrl.replace('{id}', `${channelId}`);

  const thirdPartyStreamingServiceIdStr = `${thirdPartyStreamingServiceId}`
  const activationStr                   = active ? "true" : "false"

  try
   {
    const response = await axios.patch(url, { thirdPartyStreamingServiceIdStr , activationStr , streamUrl , ingestionKey });

    console.log (url, response)

    if (response.status === 200)
          {
           return {
                    code    : 1,
                    comment : 'The streaming channel active status has been updated successfully.',
                    payload : response.data,
                  };
          }
     else {
           return handleError_ThirdPartyStreamingChannel(response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError_ThirdPartyStreamingChannel(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError_ThirdPartyStreamingChannel(-102, 'Unknown error');
   }
};



const handleError_BackendResponse = (status: number, error: string): BackendResponse_ThirdPartyStreamingServiceList => {
  return {
    code: status,
    comment: error,
    payload: [],
  };
};


export const deleteThirdPartyStreamingChannel = async (
  channelId: number
): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.deleteThirdPartyStreamingChannel}`;
  const url     = baseUrl.replace('{id}', `${channelId}`);
  
  try {
    const response = await axios.delete(url);

    if (response.status === 204) {
      return {
        code: 1,
        comment: 'The streaming channel has been deleted successfully.',
        payload: {},
      };
    } else {
      return handleError_BackendResponse(response.status, 'Non-204 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError_BackendResponse(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError_BackendResponse(-102, 'Unknown error');
  }
};

export const switchThirdPartyStreamingChannelStatus = async (
  channelData: ThirdPartyStreamingChannel
): Promise<BackendResponse> => {

  const url = `${API_URLS.switchThirdPartyStreamingChannelStatus}`;
  
  const formData = new FormData();

  // Ajout des champs principaux du canal
  formData.append ('id'                           , channelData.id.toString());
  formData.append ('active'                       , channelData.active.toString());

const headers = {
    'Accept': 'application/ld+json',
  };

  try
   {
    const response = await axios.post(url, formData, { headers }); 

    if (response.status === 200) {
      return {
        code: 1,
        comment: 'The streaming channel status has been switched successfully.',
        payload: {},
      };
    } else {
      return handleError_BackendResponse(response.status, 'Non-204 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError_BackendResponse(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError_BackendResponse(-102, 'Unknown error');
  }
};





